module.exports = {

  title: '爱乐教',

  /**
   * @type {boolean} true | false
   * @description Whether fix the header
   */
  fixedHeader: false,

  /**
   * @type {boolean} true | false
   * @description Whether show the logo in sidebar
   */
  sidebarLogo: false
}



// WEBPACK FOOTER //
// ./src/settings.js